import React from "react";
import ErrorIcon from "../../icons/error";
import { motion } from "motion/react";
import { Variants } from "../../animations/variants";

export default function SearchResultsError() {
  return (
    <motion.div
      variants={Variants.FadeInDown}
      initial="initial"
      animate="animate"
      exit="exit"
      className="dewey--search--error"
    >
      <div className="dewey--search--error--icon">
        <ErrorIcon />
      </div>
      <p className="dewey--search--error--message">Something went wrong. Please try again.</p>
    </motion.div>
  );
}
